/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVideo: {
  name: 'video';
  data: string;
} = {
  name: 'video',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.15l.438.549c1.181 1.476 3.562.64 3.562-1.25V9.851c0-1.89-2.38-2.726-3.562-1.25L18 9.15V7a2 2 0 0 0-2-2H4Zm0 2h12v10H4V7Zm14.28 5L20 9.85v4.3L18.28 12Z" fill="currentColor"/></svg>`,
};
